import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Paper,
  Typography
} from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import Drawer from '@material-ui/core/Drawer';
import Grid from '@material-ui/core/Grid';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked';
import { Link } from 'react-router-dom';
import { QUICKACTIONS } from './QuickActions';

const MainDrawer = ({
  open,
  classes,
  handleDrawerClose,
  expanded,
  handleChange,
  data
}) => {
  return (
    <Drawer
      // className={classes.drawer}
      variant='persistent'
      anchor='right'
      open={open}
      classes={{
        paper: classes.drawerPaper
      }}
    >
      <Box className={classes.quickstartHeader}>
        <Grid
          container
          alignItems='flex-end'
          justify='flex-end'
          direction='column'
        >
          <Grid item>
            <CloseIcon
              onClick={handleDrawerClose}
              style={{ color: 'white', cursor: 'pointer' }}
            />
          </Grid>
        </Grid>
        <Grid
          container
          alignItems='center'
          justify='center'
          className={classes.header}
        >
          <Grid item>
            <Typography variant='h5'>Quickstart</Typography>
          </Grid>
        </Grid>
      </Box>
      <Box className={classes.quickstartWrapper}>
        <Paper elevation={0}>
          {QUICKACTIONS.map((quickAction, index) => (
            <Accordion
              key={quickAction?.title ?? index}
              expanded={expanded === quickAction.panel}
              onChange={handleChange(quickAction.panel)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls='panel-content'
                id='panel-content'
              >
                <Checkbox
                  icon={<RadioButtonUncheckedIcon fontSize='small' />}
                  checkedIcon={<CheckCircleIcon fontSize='small' />}
                  checked={
                    data && data.data[quickAction.name] === true ? true : false
                  }
                  className={classes.stepGuide}
                />
                {/* <RadioButtonUncheckedIcon
                        fontSize='small'
                        className={classes.stepGuide}
                      /> */}
                <Typography className={classes.heading}>
                  {quickAction.title}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography className={classes.body}>
                  {quickAction.subtitle}
                </Typography>
                <Link to={quickAction.path}>{quickAction.action}</Link>
              </AccordionDetails>
            </Accordion>
          ))}
        </Paper>
      </Box>
      {/* <Typography
              color='secondary'
              style={{ textAlign: 'center', fontSize: '13px' }}
            >
              support@bizedgeapp.com
            </Typography> */}
      <Box className={classes.dismiss} style={{ textAlign: 'center' }}>
        <Box onClick={handleDrawerClose} style={{ cursor: 'pointer' }}>
          <Typography color='secondary'> Dismiss quickstart</Typography>
        </Box>
      </Box>
    </Drawer>
  );
};

export default MainDrawer;
